var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRetailers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 3.00033V0.666992H20.3333V3.00033H1.66667ZM1.66667 19.3337V12.3337H0.5V10.0003L1.66667 4.16699H20.3333L21.5 10.0003V12.3337H20.3333V19.3337H18V12.3337H13.3333V19.3337H1.66667ZM4 17.0003H11V12.3337H4V17.0003ZM2.89167 10.0003H19.1083L18.4083 6.50033H3.59167L2.89167 10.0003Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRetailers);
export default __webpack_public_path__ + "static/media/icon_retailers.0780c095fe423fb108f20b68273d2439.svg";
export { ForwardRef as ReactComponent };